import { withTheme } from '@mui/styles';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { addNotification } from '../../store/slices/ccMode';
import AudioRecorder from './AudioRecorder';
const mapStateToProps = ({ scribeConversation: { lang, speechLang, status } }) => ({
    lang,
    participants: status.participants,
    speechLang,
    status,
});
const mapDispatchToProps = {
    addNotification,
};
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withTheme(AudioRecorder)));
